import React from 'react';

const Tab = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.33822C3.63181 3.33822 3.33333 3.63669 3.33333 4.00488V5.33822C3.33333 5.70641 3.63181 6.00488 4 6.00488H12C12.3682 6.00488 12.6667 5.70641 12.6667 5.33822V4.00488C12.6667 3.63669 12.3682 3.33822 12 3.33822H4ZM2 4.00488C2 2.90031 2.89543 2.00488 4 2.00488H12C13.1046 2.00488 14 2.90031 14 4.00488V5.33822C14 6.44279 13.1046 7.33822 12 7.33822H4C2.89543 7.33822 2 6.44279 2 5.33822V4.00488Z"
        fill="#9CA3AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.99495C3.63181 9.99495 3.33333 10.2934 3.33333 10.6616V11.995C3.33333 12.3631 3.63181 12.6616 4 12.6616H12C12.3682 12.6616 12.6667 12.3631 12.6667 11.995V10.6616C12.6667 10.2934 12.3682 9.99495 12 9.99495H4ZM2 10.6616C2 9.55705 2.89543 8.66162 4 8.66162H12C13.1046 8.66162 14 9.55705 14 10.6616V11.995C14 13.0995 13.1046 13.995 12 13.995H4C2.89543 13.995 2 13.0995 2 11.995V10.6616Z"
        fill="#9CA3AF"
      />
    </svg>
  );

export default Tab;
